import { OptionType } from '@/shared/api/BaseAPI.model'
import { create } from 'zustand'

type LanguageAccordionState = {
  defaultLanguage: OptionType
  selectedLanguagesList: OptionType[]

  setDefaultLanguage: (values: OptionType) => void
  setSelectedLanguagesList: (values: OptionType[]) => void
}

export const useLanguageAccordionStore = create<LanguageAccordionState>(
  set => ({
    defaultLanguage: { value: '', label: '' },
    selectedLanguagesList: [],
    setDefaultLanguage: values =>
      set({
        defaultLanguage: values
      }),
    setSelectedLanguagesList: values => {
      set({
        selectedLanguagesList: values
      })
    }
  })
)
